
import { PropertyAttachmentDTO } from './propertyAttachmentDTO';
import { AddressDTO } from './addressDTO';

export class SoldPropertyDTO{
    public id!: number;
    public propertyId!: string;
    public businessId!: string;
    public header?: string;
    public description?: string;
    public typeId?: number;
    public subTypeId?: number;
    public address?: AddressDTO;
    public saleTypeId? : number;
    public yearBuilt? : number;
    public lotSize? : number;
    public bedrooms? : number;
    public bathroomsFull?: number;
    public bathroomsHalf?: number;
    public garages?: number;
    public carPorts?: number;
    public area?: number;
    public stories?: string;
    public units?: number;
    public latitude?: number;
    public longitude? : number;
    public attachments : PropertyAttachmentDTO[];
    public soldAt? : string;
    public soldFor? : number;

    constructor(){
        this.attachments=[];
    }
}